import {useCallback, useEffect, useState} from "react";
import Api from "../../helpers/api";
import {Autocomplete, Icon} from "@shopify/polaris";
import {SearchMinor} from "@shopify/polaris-icons";

export const CollectionsSelector = ({selected, setSelection, loading = false}) => {
    const [deselectedOptions, setDeselectedOptions] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [options, setOptions] = useState([]);

    useEffect(() => {
        Api.getCollectionsList()
            .then(({data}) => {
                setDeselectedOptions(data.data);
                setOptions(data.data);
            })
    }, []);

    const updateText = useCallback((value) => {
        setInputValue(value);

        if (value === '') {
            setOptions(deselectedOptions);
            return;
        }

        const filterRegex = new RegExp(value, 'i');
        const resultOptions = deselectedOptions.filter((option) =>
            option.title.match(filterRegex),
        );
        setOptions(resultOptions);
    }, [deselectedOptions]);

    const updateSelection = useCallback((selected) => {
        let selectedId = selected[0];
        const matchedOption = options.find((option) => {
            return option.id === selectedId;
        });

        setSelection(matchedOption?.id);
        setInputValue(matchedOption?.title ?? '');
    }, [options]);

    const textField = (
        <Autocomplete.TextField
            onChange={updateText}
            label="Collection"
            value={inputValue}
            prefix={<Icon source={SearchMinor} tone="base" />}
            placeholder="Search"
            autoComplete="off"
            disabled={loading}
        />
    );

    return (<Autocomplete
        options={options.map(item => {return {
            value: item.id,
            label: item.title,
        }})}
        selected={[selected]}
        onSelect={updateSelection}
        textField={textField}
        loading={loading}
    />);
};
